// Shared date formatting for list/table views. date-fns is already a
// dependency (see package.json), so no new package for this.
import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';

const toDate = (value) => {
  if (!value) return null;
  const parsed = typeof value === 'string' ? parseISO(value) : new Date(value);
  return isValid(parsed) ? parsed : null;
};

/** "12 Mar 2026", or an em dash when the value is missing or unparseable. */
export const formatDate = (value) => {
  const date = toDate(value);
  return date ? format(date, 'd MMM yyyy') : '—';
};

/** "12 Mar 2026, 14:05", or an em dash when the value is missing or unparseable. */
export const formatDateTime = (value) => {
  const date = toDate(value);
  return date ? format(date, 'd MMM yyyy, HH:mm') : '—';
};

/** "3 hours ago". Used for the Recent strip. */
export const formatRelative = (value) => {
  const date = toDate(value);
  return date ? `${formatDistanceToNow(date)} ago` : '—';
};
